/* eslint-disable @typescript-eslint/no-explicit-any */
import { apiCall, METHOD } from '../../service/baseApiCall'
import {
  BATCH_CREATE,
  BATCH_LIST,
  BATCH_UPDATE,
  BATCH_DETAILS,
  BATCH_DELETE,
  ADD_EMPLOYEES_TO_BATCH,
  BATCH_EXAMS,
  BATCH_BULK_UPLOAD_EXTERNAL_CANDIDATES,
  BATCH_MEMBERS,
  SEND_INVITE_TO_JOIN_BATCH,
  FETCH_BULK_UPLOAD_DETAILS,
  GET_BATCH_RESUMES,
  UPLOAD_BATCH_RESUME,
  BATCH_RESULT,
  GET_RESUME_DATA,
  GET_RESUME_LINK,
  GET_EXTERNAL_CANDIDATE,
  UPDATE_BATCH_CANDIDATE,
  GET_BATCH_INVITATION,
  ACCEPT_BATCH_INVITATION,
  SEND_UPDATED_RESUME_DATA,
  SEND_DUPLICATE_RESUME_DATA,
  GET_RECRUITMENT_JD_INVITATION,
  GET_SKILL_SET,
  SET_SKILL_SET,
  PROCESS_JS_SKILL_SET,
  GET_SKILL_SET_LIST,
} from '../constants/action-types'
import { ThunkAction } from 'redux-thunk'
import { Action, Store } from 'redux'
import {
  BATCH_URL,
  ADD_EMPLOYEES_TO_BATCH_URL,
  BATCH_BULK_UPLOAD_EMPLOYEES_URL,
  BATCH_BULK_UPLOAD_EXTERNAL_CANDIDATES_URL,
  BATCH_MEMBERS_LIST_URL,
  SEND_INVITE_TO_JOIN_BATCH_URL,
  FETCH_BULK_UPLOAD_DETAILS_URL,
  BATCH_RESULT_URL,
  PROCESS_RESUME_URL,
  GET_RESUME_LINK_URL,
  GET_BRANCH_URL,
  GET_BATCH_INVITATIONS_URL,
  ACCEPT_BATCH_INVITATIONS_URL,
  UPLOAD_RESUME_URL,
  GET_RECRUITMENT_JD_INVITATION_URL,
  GET_SKILL_SET_URL,
  PROCESS_JS_SKILL_SET_URL,
  CREATE_SKILL_SET_URL,
  GET_SKILL_SET_LIST_URL,
} from '../../service/apiEndPoints'
import { showErrorToastMessage, successToast } from '../../util/utils'
import { CancelTokenSource } from 'axios'

// ************** BATCH_LIST ******************

export const batchListData =
  (
    pageNo = 1,
    status?: string,
    jobRoleId?: number,
    perPageItem?: number,
    ordering?: Record<string, string>,
    search?: string,
    batchType?: string,
    endDate?: string
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch(
      batchListInit(
        pageNo,
        status,
        jobRoleId,
        perPageItem,
        ordering,
        search,
        batchType,
        endDate
      )
    )
  }

export const batchListInit =
  (
    pageNo,
    status?: string,
    jobRoleId?: number,
    perPageItem?: number,
    ordering?: Record<string, string>,
    search?: string,
    batchType?: string,
    endDate?: string
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    const params: any = new URLSearchParams()
    if (pageNo) params.append('page', pageNo)
    if (status) params.append('status', status)
    if (jobRoleId) params.append('job_description', jobRoleId)
    if (perPageItem) params.append('page_size', perPageItem)
    if (search) params.append('search', search)
    if (batchType) params.append('batch_type', batchType)
    if (ordering?.name)
      params.append('ordering', ordering?.name === 'desc' ? '-name' : 'name')
    dispatch({
      type: BATCH_LIST.BATCH_LIST_INITIALIZATION,
    })
    if (endDate) params?.append('academic_end_date', endDate)
    apiCall(
      BATCH_URL,
      (res: any) => dispatch(batchListSuccess(res)),
      (err: any) => {
        dispatch(batchListError(err))
      },
      { params: params },
      METHOD.GET,
      { showToast: false }
    )
  }

export const batchListSuccess =
  (res: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: BATCH_LIST.BATCH_LIST_SUCCESS,
      payload: res,
    })
  }

export const batchListError =
  (err: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: BATCH_LIST.BATCH_LIST_ERORR,
      payload: err.message,
    })
  }

// ************** CREATE BATCH ******************

export const batchCreate =
  (
    payload: object,
    _handleRedirect: (...args) => void,
    _handleFailure: (...args) => void
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch(batchCreateInit(payload, _handleRedirect, _handleFailure))
  }

export const batchCreateInit =
  (
    payload,
    _handleRedirect,
    _handleFailure
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: BATCH_CREATE.BATCH_CREATE_INITIALIZATION,
    })
    apiCall(
      BATCH_URL,
      (res: any) => dispatch(batchCreateSuccess(res, payload, _handleRedirect)),
      (err: any) => {
        dispatch(batchCreateError(err, _handleFailure))
      },
      payload,
      METHOD.POST,
      { showToast: true }
    )
  }

export const batchCreateSuccess =
  (
    res: any,
    payload,
    _handleRedirect
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: BATCH_CREATE.BATCH_CREATE_SUCCESS,
      payload: res,
    })
    _handleRedirect(res)
  }

export const batchCreateError =
  (
    err: any,
    _handleFailure
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: BATCH_CREATE.BATCH_CREATE_ERORR,
      payload: err.message,
    })
    _handleFailure(err)
  }

// ************** UPDATE BATCH ******************

export const batchUpdate =
  (
    showToast = false,
    batchId: number,
    payload,
    _handleRedirect: () => void,
    _handleFailure: () => void
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch(
      batchUpdateInit(
        showToast,
        batchId,
        payload,
        _handleRedirect,
        _handleFailure
      )
    )
  }

export const batchUpdateInit =
  (
    showToast: boolean,
    batchId: number,
    payload,
    _handleRedirect: () => void,
    _handleFailure: () => void
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: BATCH_UPDATE.BATCH_UPDATE_INITIALIZATION,
    })
    apiCall(
      BATCH_URL + '/' + batchId,
      (res: any) => dispatch(batchUpdateSuccess(res, _handleRedirect)),
      (err: any) => {
        dispatch(batchUpdateError(err, _handleFailure))
      },
      payload,
      METHOD.PATCH,
      { showToast: showToast }
    )
  }

export const batchUpdateSuccess =
  (
    res: any,
    _handleRedirect
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: BATCH_UPDATE.BATCH_UPDATE_SUCCESS,
      payload: res,
    })
    _handleRedirect()
  }

export const batchUpdateError =
  (
    err: any,
    _handleFailure
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: BATCH_UPDATE.BATCH_UPDATE_ERORR,
      payload: err.message,
    })
    _handleFailure()
  }
// ************** BATCH_DETAILS ******************

export const batchDetails =
  (
    showToast: boolean,
    ID: any,
    params?: any
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch(batchDetailsInit(showToast, ID, params))
  }

export const batchDetailsInit =
  (
    showToast: boolean,
    ID: any,
    params?: any
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: BATCH_DETAILS.BATCH_DETAILS_INITIALIZATION,
    })
    apiCall(
      BATCH_URL + `/${ID}`,
      (res: any) => dispatch(batchDetailsSuccess(res)),
      (err: any) => {
        dispatch(batchDetailsError(err))
      },
      params ? { params } : {},
      METHOD.GET,
      { showToast: showToast }
    )
  }

export const batchDetailsSuccess =
  (res: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: BATCH_DETAILS.BATCH_DETAILS_SUCCESS,
      payload: res,
    })
  }

export const batchDetailsError =
  (err: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: BATCH_DETAILS.BATCH_DETAILS_ERORR,
      payload: err.message,
    })
  }
// ************** BATCH_DELETE ******************

export const batchDelete =
  (
    ID: any,
    _handleRedirect: () => void
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch(batchDeleteInit(ID, _handleRedirect))
  }

export const batchDeleteInit =
  (
    ID: any,
    _handleRedirect
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: BATCH_DELETE.BATCH_DELETE_INITIALIZATION,
    })
    apiCall(
      BATCH_URL + `/${ID}`,
      (res: any) => dispatch(batchDeleteSuccess(res, _handleRedirect)),
      (err: any) => {
        dispatch(batchDeleteError(err))
      },
      {},
      METHOD.DELETE,
      { showToast: true }
    )
  }

export const batchDeleteSuccess =
  (
    res: any,
    _handleRedirect
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: BATCH_DELETE.BATCH_DELETE_SUCCESS,
      payload: res,
    })
    _handleRedirect()
  }

export const batchDeleteError =
  (err: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: BATCH_DELETE.BATCH_DELETE_ERORR,
      payload: err.message,
    })
  }

// ************** ADD CANDIDATES TO BATCH  ******************

export const addEmployeesToBatch =
  (
    ID: any,
    payload: object,
    _handleRedirect: () => void,
    _handleFailure: () => void
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch(
      addEmployeesToBatchInit(ID, payload, _handleRedirect, _handleFailure)
    )
  }

export const addEmployeesToBatchInit =
  (
    ID: any,
    payload: object,
    _handleRedirect,
    _handleFailure
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: ADD_EMPLOYEES_TO_BATCH.ADD_EMPLOYEES_TO_BATCH_INITIALIZATION,
    })
    apiCall(
      ADD_EMPLOYEES_TO_BATCH_URL.replace('<batch_id>', ID),
      (res: any) => dispatch(addEmployeesToBatchSuccess(res, _handleRedirect)),
      (err: any) => {
        dispatch(addEmployeesToBatchError(err, _handleFailure))
      },
      payload,
      METHOD.POST,
      { showToast: false }
    )
  }

export const addEmployeesToBatchSuccess =
  (
    res: any,
    _handleRedirect
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: ADD_EMPLOYEES_TO_BATCH.ADD_EMPLOYEES_TO_BATCH_SUCCESS,
      payload: res,
    })
    _handleRedirect()
  }

export const addEmployeesToBatchError =
  (
    err: any,
    _handleFailure
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  () => {
    showErrorToastMessage(
      err?.data?.employees ? err.data.employees.toString() : err?.message
    )
  }

// ************** BATCH_EXAM ******************

export const batchExamListData =
  (batchId: number): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch(batchExamListInit(batchId))
  }

export const batchExamListInit =
  (batchId: number): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: BATCH_EXAMS.GET_BATCH_EXAMS_INITIALIZATION,
    })
    const params: any = new URLSearchParams()
    params.append('status', 'RESULT_GENERATED')
    params.append('status', 'EVALUATING_RESULT')
    params.append('status', 'ACTIVE')
    params.append('get_performance', true)
    params.append('batch', batchId)
    apiCall(
      '/api/exam',
      (res: any) => dispatch(batchExamListSuccess(res)),
      (err: any) => {
        dispatch(batchExamListError(err))
      },
      { params },
      METHOD.GET,
      { showToast: false }
    )
  }

export const batchExamListSuccess =
  (res: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: BATCH_EXAMS.GET_BATCH_EXAMS_SUCCESS,
      payload: res,
    })
  }

export const batchExamListError =
  (err: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: BATCH_EXAMS.GET_BATCH_EXAMS_ERROR,
      payload: err.message,
    })
  }

// ************** Bulk Upload Employees ******************

export const bulkUploadEmployees =
  (
    batchId: any,
    payload: object,
    _handleRedirect: () => void,
    _handleFailure: () => void
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch(
      bulkUploadEmployeesInit(batchId, payload, _handleRedirect, _handleFailure)
    )
  }

export const bulkUploadEmployeesInit =
  (
    batchId: any,
    payload: object,
    _handleRedirect: () => void,
    _handleFailure: () => void
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: BATCH_BULK_UPLOAD_EXTERNAL_CANDIDATES.BATCH_BULK_UPLOAD_EXTERNAL_CANDIDATES_INITIALIZATION,
    })
    apiCall(
      BATCH_BULK_UPLOAD_EMPLOYEES_URL.replace('<batch_id>', batchId),
      (res: any) => dispatch(bulkUploadEmployeesSuccess(res, _handleRedirect)),
      (err: any) => {
        dispatch(bulkUploadEmployeesError(err, _handleFailure))
      },
      payload,
      METHOD.POST,
      { showToast: false }
    )
  }

export const bulkUploadEmployeesSuccess =
  (
    res: any,
    _handleRedirect
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: BATCH_BULK_UPLOAD_EXTERNAL_CANDIDATES.BATCH_BULK_UPLOAD_EXTERNAL_CANDIDATES_SUCCESS,
      payload: res,
    })
    _handleRedirect()
  }

export const bulkUploadEmployeesError =
  (
    err: any,
    _handleFailure
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: BATCH_BULK_UPLOAD_EXTERNAL_CANDIDATES.BATCH_BULK_UPLOAD_EXTERNAL_CANDIDATES_ERROR,
      payload: err.message,
    })
    _handleFailure()
  }
// ************** Bulk Upload External Candidates ******************

export const bulkUploadExternalCandidates =
  (
    batchId: any,
    payload: object,
    _handleRedirect: () => void,
    _handleFailure: () => void
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch(
      bulkUploadExternalCandidatesInit(
        batchId,
        payload,
        _handleRedirect,
        _handleFailure
      )
    )
  }

export const bulkUploadExternalCandidatesInit =
  (
    batchId: any,
    payload: object,
    _handleRedirect: () => void,
    _handleFailure: () => void
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: BATCH_BULK_UPLOAD_EXTERNAL_CANDIDATES.BATCH_BULK_UPLOAD_EXTERNAL_CANDIDATES_INITIALIZATION,
    })
    apiCall(
      BATCH_BULK_UPLOAD_EXTERNAL_CANDIDATES_URL.replace('<batch_id>', batchId),
      (res: any) =>
        dispatch(bulkUploadExternalCandidatesSuccess(res, _handleRedirect)),
      (err: any) => {
        dispatch(bulkUploadExternalCandidatesError(err, _handleFailure))
      },
      payload,
      METHOD.POST,
      { showToast: false }
    )
  }

export const bulkUploadExternalCandidatesSuccess =
  (
    res: any,
    _handleRedirect
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: BATCH_BULK_UPLOAD_EXTERNAL_CANDIDATES.BATCH_BULK_UPLOAD_EXTERNAL_CANDIDATES_SUCCESS,
      payload: res,
    })
    _handleRedirect()
  }

export const bulkUploadExternalCandidatesError =
  (
    err: any,
    _handleFailure
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: BATCH_BULK_UPLOAD_EXTERNAL_CANDIDATES.BATCH_BULK_UPLOAD_EXTERNAL_CANDIDATES_ERROR,
      payload: err.message,
    })
    _handleFailure()
  }

// ************** BATCH MEMBERS LIST ******************
export const batchMembersListData =
  (
    batchID: any,
    pageNo?: number,
    cancelToken?: CancelTokenSource,
    activeUser?: boolean,
    search?: string,
    view_member?: boolean
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch(
      batchMembersListDataInit(
        batchID,
        pageNo,
        cancelToken,
        activeUser,
        search,
        view_member
      )
    )
  }

export const batchMembersListDataInit =
  (
    batchID,
    pageNo,
    cancelToken?: CancelTokenSource,
    activeUser?: boolean,
    search?: string,
    view_member?: boolean
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: BATCH_MEMBERS.BATCH_MEMBERS_INITIALIZATION,
    })
    apiCall(
      BATCH_MEMBERS_LIST_URL.replace('<batch_id>', batchID),
      (res: any) => dispatch(batchMembersListDataSuccess(res)),
      (err: any) => {
        dispatch(batchMembersListDataError(err))
      },
      {
        params: {
          page: pageNo,
          active: activeUser,
          search: search ? search : undefined,
          view_member: view_member ? view_member : undefined,
        },
        cancelToken: cancelToken?.token,
      },
      METHOD.GET,
      { showToast: false }
    )
  }

export const batchMembersListDataSuccess =
  (res: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: BATCH_MEMBERS.BATCH_MEMBERS_SUCCESS,
      payload: res,
    })
  }

export const batchMembersListDataError =
  (err: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: BATCH_MEMBERS.BATCH_MEMBERS_ERROR,
      payload: err.message,
    })
  }

// ************** SEND INVITE TO JOIN BATCH ******************

export const sendInviteToJoinBatch =
  (
    batchId: any,
    payload: object,
    _handleRedirect: () => void,
    _handleFailure: () => void
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch(
      sendInviteToJoinBatchInit(
        batchId,
        payload,
        _handleRedirect,
        _handleFailure
      )
    )
  }

export const sendInviteToJoinBatchInit =
  (
    batchId: any,
    payload: object,
    _handleRedirect: () => void,
    _handleFailure: () => void
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: SEND_INVITE_TO_JOIN_BATCH.SEND_INVITE_TO_JOIN_BATCH_INITIALIZATION,
    })
    apiCall(
      SEND_INVITE_TO_JOIN_BATCH_URL.replace('<batch_id>', batchId),
      (res: any) =>
        dispatch(sendInviteToJoinBatchSuccess(res, _handleRedirect)),
      (err: any) => {
        dispatch(sendInviteToJoinBatchError(err, _handleFailure))
      },
      payload,
      METHOD.POST,
      { showToast: true }
    )
  }

export const sendInviteToJoinBatchSuccess =
  (
    res: any,
    _handleRedirect
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: SEND_INVITE_TO_JOIN_BATCH.SEND_INVITE_TO_JOIN_BATCH_SUCCESS,
      payload: res,
    })
    _handleRedirect()
  }

export const sendInviteToJoinBatchError =
  (
    err: any,
    _handleFailure
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: SEND_INVITE_TO_JOIN_BATCH.SEND_INVITE_TO_JOIN_BATCH_ERROR,
      payload: err.message,
    })
    _handleFailure()
  }

// ************** Fetch Bulk Upload Details ******************

export const fetchBulkUploadDetails =
  (Id: number): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch(fetchBulkUploadDetailsInit(Id))
  }

export const fetchBulkUploadDetailsInit =
  (Id: number): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    const params: any = new URLSearchParams()
    params.append('id', Id)
    dispatch({
      type: FETCH_BULK_UPLOAD_DETAILS.FETCH_BULK_UPLOAD_DETAILS_INITIALIZATION,
    })
    apiCall(
      FETCH_BULK_UPLOAD_DETAILS_URL,
      (res: any) => dispatch(fetchBulkUploadDetailsSuccess(res)),
      (err: any) => {
        dispatch(fetchBulkUploadDetailsError(err))
      },
      { params: params },
      METHOD.GET,
      { showToast: false }
    )
  }

export const fetchBulkUploadDetailsSuccess =
  (res: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: FETCH_BULK_UPLOAD_DETAILS.FETCH_BULK_UPLOAD_DETAILS_SUCCESS,
      payload: res,
    })
  }

export const fetchBulkUploadDetailsError =
  (err: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: FETCH_BULK_UPLOAD_DETAILS.FETCH_BULK_UPLOAD_DETAILS_ERROR,
      payload: err.message,
    })
  }

// ************** BATCH_RESULT ******************

export const batchResult =
  (batchId: number): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: BATCH_RESULT.BATCH_RESULT_INITIALIZATION,
    })
    apiCall(
      BATCH_RESULT_URL,
      (res: any) => {
        dispatch({
          type: BATCH_RESULT.BATCH_RESULT_SUCCESS,
          payload: res,
        })
      },
      () => {
        dispatch({
          type: BATCH_RESULT.BATCH_RESULT_ERROR,
        })
      },
      { params: { batch: batchId, page: 1 } },
      METHOD.GET,
      {
        showToast: false,
      }
    )
  }

// ************** GET_BATCH_RESUMES ******************

export const getBatchResumes = (
  page?: number,
  jobRoleId?: number,
  ordering?: Record<string, string>,
  search?: string,
  pageSize?: number,
  batchId?: number,
  status?: string,
  isInvited?: boolean
): ThunkAction<void, Store, unknown, Action<string>> => {
  return (dispatch) => {
    dispatch({
      type: GET_BATCH_RESUMES.GET_BATCH_RESUMES_INITIALIZATION,
    })
    const params = new URLSearchParams()
    page && params.append('page', page?.toString())
    batchId && params.append('batch', batchId?.toString())
    jobRoleId && params.append('jd_id', jobRoleId?.toString())
    search && params.append('search', search)
    pageSize && params.append('page_size', pageSize?.toString())
    status && params.append('status', status)
    isInvited && params.append('is_invited', isInvited?.toString())
    ordering?.created_at &&
      params.append(
        'ordering',
        ordering?.created_at === 'desc' ? '-created_at' : 'created_at'
      )
    ordering?.name &&
      params.append('ordering', ordering?.name === 'desc' ? '-id' : 'id')
    apiCall(
      `${BATCH_URL}/batch-resume`,
      (res) => {
        dispatch({
          type: GET_BATCH_RESUMES.GET_BATCH_RESUMES_SUCCESS,
          payload: page ? res?.data : { results: res?.data },
        })
      },
      () => {
        dispatch({
          type: GET_BATCH_RESUMES.GET_BATCH_RESUMES_ERROR,
        })
      },
      { params },
      METHOD.GET,
      {}
    )
  }
}

// ************** GET_BATCH_RESUMES ******************

export const uploadBatchResumes = (
  batchId: number,
  resumes: File[],
  handleSuccess?: () => void
): ThunkAction<void, Store, unknown, Action<string>> => {
  return (dispatch) => {
    dispatch({
      type: UPLOAD_BATCH_RESUME.UPLOAD_BATCH_RESUME_INITIALIZATION,
    })
    const payload = new FormData()
    for (const resume of resumes) {
      payload.append('resume', resume)
    }
    apiCall(
      `${BATCH_URL}/${batchId}/upload-batch-resume`,
      (res) => {
        dispatch({
          type: UPLOAD_BATCH_RESUME.UPLOAD_BATCH_RESUME_SUCCESS,
          payload: res?.data,
        })
        handleSuccess && handleSuccess()
      },
      () => {
        dispatch({
          type: UPLOAD_BATCH_RESUME.UPLOAD_BATCH_RESUME_FAILED,
        })
      },
      payload,
      METHOD.POST,
      {}
    )
  }
}

// ************** Upload Resume to Extract Data ******************

export const uploadResumesToExtractData = (
  resumeFiles: File[],
  userInfo: { user_name: string; user_id: string },
  skillSet: string[],
  handleSuccess?: (...args) => void
): ThunkAction<void, Store, unknown, Action<string>> => {
  return (dispatch) => {
    dispatch({
      type: GET_RESUME_DATA.GET_RESUME_DATA_INITIALIZATION,
    })
    const payload = new FormData()
    for (const resume of resumeFiles) {
      payload.append('resume_files', resume)
    }
    payload.append('user_info', JSON.stringify(userInfo))
    payload.append('skill_set', JSON.stringify(skillSet))
    apiCall(
      `${process.env.REACT_APP_RESUME_READER_URL}${PROCESS_RESUME_URL}`,
      (res) => {
        dispatch({
          type: GET_RESUME_DATA.GET_RESUME_DATA_SUCCESS,
          payload: res,
        })
        handleSuccess && handleSuccess(res)
      },
      (err) => {
        dispatch({
          type: GET_RESUME_DATA.GET_RESUME_DATA_FAILED,
        })
        showErrorToastMessage('Something went wrong')
      },
      payload,
      METHOD.POST,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    )
  }
}

// ************** Get Resume Link ******************

export const getResumes = (
  payload,
  fileName,
  handleSuccess?: (...args) => void,
  callback?: () => void
): ThunkAction<void, Store, unknown, Action<string>> => {
  return (dispatch) => {
    dispatch({
      type: GET_RESUME_LINK?.GET_RESUME_LINK_INITIALIZATION,
    })
    apiCall(
      `${process.env.REACT_APP_RESUME_READER_URL}${GET_RESUME_LINK_URL}`,
      (res) => {
        dispatch({
          type: GET_RESUME_LINK.GET_RESUME_LINK_SUCCESS,
        })
        if (res?.url) {
          const link = document.createElement('a')
          link.href = res?.url
          link.setAttribute('download', fileName)
          link.setAttribute('target', '_blank')
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          handleSuccess && handleSuccess(res)
        } else {
          showErrorToastMessage('Resume not found')
        }
        callback && callback()
      },
      (err) => {
        dispatch({
          type: GET_RESUME_LINK.GET_RESUME_LINK_FAILED,
        })
        showErrorToastMessage('Something went wrong')
        callback && callback()
      },
      { params: { ...payload } },
      METHOD.GET,
      {}
    )
  }
}

// ************** Fetch Candidates of institute ******************
export const getInstituteCandidates =
  (
    instituteId: number,
    roles?: string[],
    exclude_batch?: number
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: GET_EXTERNAL_CANDIDATE.GET_EXTERNAL_CANDIDATE_INITIALIZATION,
    })
    const params = new URLSearchParams()
    if (roles?.length) {
      for (const role of roles) {
        params.append('role', role)
      }
    }
    exclude_batch && params?.append('exclude_batch', exclude_batch?.toString())
    apiCall(
      `${GET_BRANCH_URL}/${instituteId}/institute-employee-list`,
      (res: any) => {
        dispatch({
          type: GET_EXTERNAL_CANDIDATE.GET_EXTERNAL_CANDIDATE_SUCCESS,
          payload: res?.data || [],
        })
      },
      () => {
        dispatch({
          type: GET_EXTERNAL_CANDIDATE.GET_EXTERNAL_CANDIDATE_FAILED,
        })
      },
      { params },
      METHOD.GET,
      { showToast: false }
    )
  }

// ************** Update Batch Candidate Status ******************
export const updateBatchCandidateStatus = (
  batchId: number,
  user: number[],
  status: string,
  onSuccess?: () => void
): ThunkAction<void, Store, unknown, Action<string>> => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_BATCH_CANDIDATE.UPDATE_BATCH_CANDIDATE_INITIALIZATION,
    })
    apiCall(
      `${BATCH_URL}/${batchId}/update-employee`,
      () => {
        dispatch({
          type: UPDATE_BATCH_CANDIDATE.UPDATE_BATCH_CANDIDATE_SUCCESS,
        })
        if (status === 'D') {
          successToast('Member deleted successfully')
        }
        if (status === 'A') {
          successToast('Member activated successfully')
        }
        if (status === 'I') {
          successToast('Member deactivated successfully')
        }
        onSuccess && onSuccess()
      },
      () => {
        dispatch({
          type: UPDATE_BATCH_CANDIDATE.UPDATE_BATCH_CANDIDATE_FAILED,
        })
        showErrorToastMessage('Something went wrong')
      },
      { employee_list: user?.map((user) => ({ user, status })) },
      METHOD.PUT,
      {}
    )
  }
}

// ************** Get batch invitations for external candidates  ******************
export const getBatchInvitations = (
  params: URLSearchParams,
  onSuccess?: () => void
): ThunkAction<void, Store, unknown, Action<string>> => {
  return (dispatch) => {
    dispatch({
      type: GET_BATCH_INVITATION.GET_BATCH_INVITATION_INITIALIZATION,
    })
    apiCall(
      GET_BATCH_INVITATIONS_URL,
      (res) => {
        dispatch({
          type: GET_BATCH_INVITATION.GET_BATCH_INVITATION_SUCCESS,
          payload: res.data,
        })
        onSuccess && onSuccess()
      },
      () => {
        dispatch({
          type: GET_BATCH_INVITATION.GET_BATCH_INVITATION_FAILED,
        })
        showErrorToastMessage('Something went wrong')
      },
      { params },
      METHOD.GET,
      {}
    )
  }
}

// ************** Accept batch invitations for external candidates  ******************
export const acceptBatchInvitations = (
  requestId: number,
  payload: Record<string, string | number>,
  onSuccess?: () => void,
  onFailure?: () => void
): ThunkAction<void, Store, unknown, Action<string>> => {
  return (dispatch) => {
    dispatch({
      type: ACCEPT_BATCH_INVITATION.ACCEPT_BATCH_INVITATION_INITIALIZATION,
    })
    apiCall(
      ACCEPT_BATCH_INVITATIONS_URL.replace('REQUEST_ID', requestId?.toString()),
      (res) => {
        dispatch({
          type: ACCEPT_BATCH_INVITATION.ACCEPT_BATCH_INVITATION_SUCCESS,
          payload: res.data,
        })
        successToast(
          `Batch invitation ${
            payload.status === 'ACC' ? 'accepted' : 'declined'
          }`
        )
        onSuccess && onSuccess()
      },
      (err) => {
        dispatch({
          type: GET_BATCH_INVITATION.GET_BATCH_INVITATION_FAILED,
        })
        onFailure && onFailure()
        showErrorToastMessage(err?.message || 'Something went wrong')
      },
      payload,
      METHOD.PUT,
      {}
    )
  }
}

export const uploadResumesInBatch = (
  payload: Record<string, string | boolean | number | string[] | undefined>[],
  batchId: number,
  send_email?: boolean,
  onSuccess?: () => void,
  _handleFailure?: (...args) => void
): ThunkAction<void, Store, unknown, Action<string>> => {
  return (dispatch) => {
    dispatch({
      type: UPLOAD_BATCH_RESUME.UPLOAD_BATCH_RESUME_INITIALIZATION,
    })
    const requestBody: any = { resume_data: payload }
    if (typeof send_email !== 'undefined') {
      requestBody.send_email = send_email
    }
    apiCall(
      UPLOAD_RESUME_URL?.replace('BATCH_ID', batchId?.toString()),
      () => {
        dispatch({
          type: UPLOAD_BATCH_RESUME.UPLOAD_BATCH_RESUME_SUCCESS,
        })
        onSuccess && onSuccess()
      },
      (err) => {
        dispatch({
          type: UPLOAD_BATCH_RESUME.UPLOAD_BATCH_RESUME_FAILED,
        })
        showErrorToastMessage('Something went wrong')
        _handleFailure && _handleFailure(err)
      },
      requestBody,
      METHOD.POST,
      {}
    )
  }
}

export const setUpdateResumeData =
  (updateResumeData): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: SEND_UPDATED_RESUME_DATA.SEND_UPDATED_RESUME_DATA_INITIALIZATION,
      payload: updateResumeData,
    })
  }

export const setDuplicateResumeData =
  (duplicateResumeData): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: SEND_DUPLICATE_RESUME_DATA.SEND_DUPLICATE_RESUME_DATA_INITIALIZATION,
      payload: duplicateResumeData,
    })
  }

export const getJDInvitations = (
  params: URLSearchParams,
  onSuccess?: () => void
): ThunkAction<void, Store, unknown, Action<string>> => {
  return (dispatch) => {
    dispatch({
      type: GET_RECRUITMENT_JD_INVITATION.GET_RECRUITMENT_JD_INVITATION_INITIALIZATION,
    })
    apiCall(
      GET_RECRUITMENT_JD_INVITATION_URL,
      (res) => {
        dispatch({
          type: GET_RECRUITMENT_JD_INVITATION.GET_RECRUITMENT_JD_INVITATION_SUCCESS,
          payload: res.data,
        })
        onSuccess && onSuccess()
      },
      () => {
        dispatch({
          type: GET_RECRUITMENT_JD_INVITATION.GET_RECRUITMENT_JD_INVITATION_FAILED,
        })
        showErrorToastMessage('Something went wrong')
      },
      { params },
      METHOD.GET,
      {}
    )
  }
}

// ************** GET_SKILL_SET ******************
/**
 * get skillset
 * @param page
 * @param job_description
 * @param search
 * @returns
 */
export const getSkillSetThunk = (
  params: URLSearchParams,
  onSuccess?: () => void
): ThunkAction<void, Store, unknown, Action<string>> => {
  return (dispatch) => {
    dispatch({
      type: GET_SKILL_SET.GET_SKILL_SET_INITIALIZATION,
    })
    apiCall(
      GET_SKILL_SET_URL,
      (res) => {
        dispatch({
          type: GET_SKILL_SET.GET_SKILL_SET_SUCCESS,
          payload: res.data,
        })
        onSuccess && onSuccess()
      },
      () => {
        dispatch({
          type: GET_SKILL_SET.GET_SKILL_SET_ERROR,
        })
        showErrorToastMessage('Something went wrong')
      },
      { params },
      METHOD.GET,
      {}
    )
  }
}

// ************** SET_SKILL_SET ******************
export const createSkillSetThunk = (
  payload: { skill_name: string[]; job_description: number },
  onSuccess?: () => void,
  _handleFailure?: (...args) => void
): ThunkAction<void, Store, unknown, Action<string>> => {
  return (dispatch) => {
    dispatch({
      type: SET_SKILL_SET.SET_SKILL_SET_INITIALIZATION,
    })
    apiCall(
      CREATE_SKILL_SET_URL,
      () => {
        dispatch({
          type: SET_SKILL_SET.SET_SKILL_SET_SUCCESS,
        })
        onSuccess && onSuccess()
      },
      (err) => {
        dispatch({
          type: SET_SKILL_SET.SET_SKILL_SET_ERROR,
        })
        showErrorToastMessage('Something went wrong')
        _handleFailure && _handleFailure(err)
      },
      payload,
      METHOD.POST,
      {}
    )
  }
}

// ************** PROCESS_JD_SKILL_SET ******************
export const processJDSkillSetThunk = (
  payload: Record<string, any>,
  onSuccess?: (...args) => void,
  _handleFailure?: (...args) => void
): ThunkAction<void, Store, unknown, Action<string>> => {
  return (dispatch) => {
    dispatch({
      type: PROCESS_JS_SKILL_SET.PROCESS_JS_SKILL_SET_INITIALIZATION,
    })
    apiCall(
      `${process.env.REACT_APP_RESUME_READER_URL}${PROCESS_JS_SKILL_SET_URL}`,
      (res) => {
        dispatch({
          type: PROCESS_JS_SKILL_SET.PROCESS_JS_SKILL_SET_SUCCESS,
        })
        onSuccess && onSuccess(res)
      },
      (err) => {
        dispatch({
          type: PROCESS_JS_SKILL_SET.PROCESS_JS_SKILL_SET_ERROR,
        })
        showErrorToastMessage('Something went wrong')
        _handleFailure && _handleFailure(err)
      },
      payload,
      METHOD.POST,
      {}
    )
  }
}

// ************** GET_SKILL_SET_LIST ******************
/**
 * get skillset
 * @returns
 */
export const getSkillSetListThunk = (): ThunkAction<
  void,
  Store,
  unknown,
  Action<string>
> => {
  return (dispatch) => {
    dispatch({
      type: GET_SKILL_SET_LIST.GET_SKILL_SET_LIST_INITIALIZATION,
    })
    apiCall(
      GET_SKILL_SET_LIST_URL,
      (res) => {
        dispatch({
          type: GET_SKILL_SET_LIST.GET_SKILL_SET_LIST_SUCCESS,
          payload: res.data,
        })
      },
      () => {
        dispatch({
          type: GET_SKILL_SET_LIST.GET_SKILL_SET_LIST_ERROR,
        })
        showErrorToastMessage('Something went wrong')
      },
      {},
      METHOD.GET,
      {}
    )
  }
}
